import Page from '@/features/Services/pages/Vendor'

export default Page
